export const PARENT_NAME_MAX_LENGTH = 40;
export const PARENT_NAME_MIN_WORDS = 2;

export const PARENT_NAME_MESSAGES = {
  motherRequired: "É necessário informar o nome da mãe.",
  motherTwoWords: "Informe o nome e o sobrenome da mãe.",
  motherMaxLength: "O nome da mãe deve ter no máximo 40 caracteres.",
  fatherMaxLength: "O nome do pai deve ter no máximo 40 caracteres."
} as const;

export const limitParentName = (value: string): string =>
  value.slice(0, PARENT_NAME_MAX_LENGTH);

export const getParentNameWordCount = (value: string): number => {
  const words = value.trim().split(/\s+/).filter(Boolean);
  return words.length;
};

export const hasMinimumParentNameWords = (value: string): boolean =>
  getParentNameWordCount(value) >= PARENT_NAME_MIN_WORDS;

export const sanitizeParentNameForApi = (
  value?: string | null
): string | undefined => {
  if (value == null) {
    return undefined;
  }

  const limited = limitParentName(value);
  if (!hasMinimumParentNameWords(limited)) {
    return undefined;
  }

  return limited;
};
